import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import 'lib-flexible/flexible'
import '@/utils/rem.js'
// 自动滚动
// import VueScroll from "@david-j/vue-j-scroll";
// Vue.use(VueScroll)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.filter('formatNumber', function (value = '0', currencyType = '') {
  let res;
  if (value.toString().indexOf('.') === -1) {
    res = (value || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  } else {
    let prev = value.toString().split('.')[0]
    let next = value.toString().split('.')[1] < 10 ? value.toString().split('.')[1] + '0' : value.toString().split('.')[1]
    res = (prev || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + next
  }
  return currencyType + res
});
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
